<article class="result-detail-layout2">

  <!-- TODO: 로딩 중이라는 표현 추가해야함! -->

  <ng-container *ngIf="dialect">

    <div class="head-tit-box">

      <div class="head-txt-box">

        <div class="place-box">
          <article class="place-list-layout">
            <div class="place-label-list">

              <div class="place-label-box fix main-type{{ GetRegion2Css(dialect.area1) }}">
                {{ GetRegion2Name(dialect.area1) }}
              </div>

              <!-- div *ngIf="dialect.area2"
                   class="place-label-box fix sub-type{{ GetRegion2Css(dialect.area1) }}">
                {{ dialect.area2 }}
              </div -->

            </div>
          </article>
        </div>

        <div class="tit-box"
             [innerHTML]="dialect.word | resize | keepHtml"></div>
      </div>

      <div class="option-list">
        <div class="option-box">
          <article class="bookmark-btn-box">
            <a class="bookmark-btn type-big {{ getBmCss(dialect) }}"
               (click)="ToggleBookmark($event, dialect)"></a>
          </article>
        </div>

        <!-- div class="option-box">
          <a class="toggle-btn"
             (click)="onOpen($event)"></a>
        </div -->

      </div>


    </div>

    <div class="detail-info-box">

      <div class="info-contents-box">

        <div class="info-item-box standard-info-box"
             *ngIf="dialect.standard || dialect.standardWord">
          <ng-container #standardWordPopupAnchor></ng-container>
          <div class="subject-box align-center">
            <div class="border-box">표준말</div>
          </div>
          <div class="con-box">
            <div class="keyword-txt-box"
                 *ngIf="dialect.standard">
              <app-word-disp [word]="dialect.standard"
                             [linkPopup]="true"
                             [popupContainer]="standardWordContainer"
                             [popupLeftOffset]="-10"
                             [popupZIndex]="501"
                             [wrapHanja]="true"
                             [wrapReservedWidth]="dialect.standard.wordVoice ? 52 : 0"
                             class="smaller tooltip-target"></app-word-disp>
              <div *ngIf="dialect.standard.wordVoice"
                   class="detail-option-box">
                <!-- 소리 재생 버튼 -->
                <app-dialect-word-play-btn [word]="dialect.standard"></app-dialect-word-play-btn>

              </div>
            </div>

            <div *ngIf="!dialect.standard && dialect.standardWord"
                 class="standard-word"
                 [innerHTML]="dialect.standardWord | resize | keepHtml"></div>


          </div>
        </div>

        <div class="info-item-box">
          <div class="subject-box">
            <div class="border-box"><span class="subject-txt">뜻</span></div>
          </div>
          <div class="con-box">

            <ng-container *ngFor="let meaning3 of dialect.meaning3; let idx = index">

              <div class="meaning-box" *ngIf="dialect.GetMeaning3Nth(idx)">

                <div class="txt-list-box">
                  <div class="meaning-num"
                       *ngIf="idx !== 0">{{ idx }}.</div>

                  <app-link-content class="txt-box"
                                    [popupAlignLeftSelector]="'.standard-info-box'"
                                    [popupLeftOffset]="-10"
                                    [popupZIndex]="501"
                                    [content]="dialect.GetMeaning3Nth(idx) | slash2br | resize"></app-link-content>
                </div>

                <div *ngIf="dialect.GetExample3Nth(idx)"
                     class="txt-list-box">

                  <div class="example-box">
                    <span class="example-txt">예</span>
                  </div>
                  <app-link-content class="txt-box"
                                    [popupAlignLeftSelector]="'.standard-info-box'"
                                    [popupLeftOffset]="-10"
                                    [popupZIndex]="501"
                                    [content]="dialect.GetExample3Nth(idx) | slash2br | resize"></app-link-content>
                </div>

                <div *ngIf="dialect.GetExplanation3Nth(idx)"
                     class="txt-list-box">

                  <div class="example-box">
                    <span class="example-txt">풀이</span>
                  </div>
                  <app-link-content class="txt-box"
                                    [popupAlignLeftSelector]="'.standard-info-box'"
                                    [popupLeftOffset]="-10"
                                    [popupZIndex]="501"
                                    [content]="dialect.GetExplanation3Nth(idx) | slash2br | resize"></app-link-content>
                </div>
              </div>

            </ng-container>

          </div>
        </div>

        <!-- div *ngIf="dialect.example3"
             class="info-item-box">

          <div class="subject-box">
            <div class="border-box"><span class="subject-txt">예</span></div>
          </div>
          <div class="con-box">
            <div class="txt-list-box">

              <app-link-content class="txt-box"
                                [content]="example3 | slash2br | resize"></app-link-content>

              <div *ngIf="example3sub"
                   class="sub-txt-box">{{ example3sub }}</div>

            </div>

          </div>
        </div -->

        <div *ngIf="hasSimilar"
             class="info-item-box similar-info-box">
          <ng-container #similarContainer></ng-container>
          <div class="subject-box">
            <div class="border-box"><span class="subject-txt">비슷한 말</span></div>
          </div>
          <div class="con-box">

            <div class="meaning-box">

              <div class="txt-list-box">
                <div class="con-box">
                  <div *ngFor="let more of sameAreaDialects"
                       class="txt-box similar-box similar-dialect-box"
                       (click)="onClickSimilarDialect($event, more)">
                    {{ more.word }}
                  </div>
                  <div *ngFor="let more of similarWords"
                       class="txt-box similar-box">{{ more }}</div>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>

    </div>


    <div class="detail-other-box"
         *ngIf="otherAreaDialects.length > 0">

      <app-dialect-map-btn [dialects]="otherAreaDialects"
                           [word]="dialect.standard ?? null"></app-dialect-map-btn>

      <div class="other-list">

        <app-dialect-item *ngFor="let other of otherAreaDialects"
                          [dialect]="other"
                          [inDetail]="true"
                          [linkPopup]="true"
                          [showNavigationArrow]="true"></app-dialect-item>

      </div>
    </div>
  </ng-container>
</article>
